import React from "react";

import { useTranslation, Trans } from "react-i18next";

import Button from '../Button'

import tt from '../../img/Home/phonetablet.png'
import m1 from '../../img/Home/m1.png'
import m2 from '../../img/Home/m2.png'

import Rotate from 'react-reveal/Rotate';
import Fade from 'react-reveal/Fade';

function Main () {

    const { t } = useTranslation();
      
    return(
        <div className="relative bg-[#0C2780] max-w-[1920px] mx-auto pt-[100px]">
            <div className="max-w-[1220px] xl:mx-auto mx-[20px]">
                <div className="flex flex-col xl:flex-row justify-between items-center xl:items-start">
                    <div className="flex flex-col items-center xl:pb-[250px] xl:mt-[180px]">
                        <p className="open-sans text-[50px] xl:text-[85px] text-[#EFEFEF] font-[700]">{t('home.1')}</p>
                        <p className="open-sans text-[50px] xl:text-[85px] text-[#EFEFEF] font-[700] leading-[1]">{t('home.2')}</p>
                        <p className="open-sans text-[22px] xl:text-[37px] text-[#EFEFEF] mt-[15px] xl:mt-[50px]">{t('home.3')}</p>          
                        <Button color={'#EFEFEF'} text={'#0C2780'} className={'mt-[30px] xl:mt-[50px]'}/>             
                    </div>
                    <div>
                        <Fade right><img src={tt} alt="" className="absolute right-0 pl-[120px] bottom-[50px] xl:bottom-[120px] z-50"/></Fade>
                        <div className="xl:absolute right-[100px] mt-[50px]">
                            <Rotate duration={2000}><img src={m2} className="" alt="" /></Rotate>
                            <div className="absolute xl:top-[110px] bottom-[40px] left-1/2 -translate-x-1/2 xl:left-auto xl:-translate-x-0 w-[80%] md:w-auto xl:right-[80px]"><Rotate delay={500} duration={2000}><img src={m1} alt="" /></Rotate></div>
                        </div>
                    </div>
                </div>              
            </div>
        </div>
    );
}

export default Main;